// extracted by mini-css-extract-plugin
export default {"sliderContainer":"image_slider_sliderContainer__ESa4X"};